import type { SVGProps } from 'react';
const SvgCameraRear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#camera_rear_svg__a)">
      <path
        fill="currentColor"
        d="M10 20H5v2h5v2l3-3-3-3v2Zm4 0v2h5v-2h-5Zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm-5 6a2 2 0 0 1-2-2c0-1.1.89-2 1.99-2s2 .9 2 2C14 5.1 13.1 6 12 6Z"
      />
    </g>
    <defs>
      <clipPath id="camera_rear_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCameraRear;
